import type { FC } from 'react';
import TokenPageAboutCard from '../AboutCard/AboutCard';

export interface TokenPageAboutProps {
    tokenName: string;
    className?: string;
}

const TokenPageAboutTab: FC<TokenPageAboutProps> = props => {
    const { tokenName, className = '' } = props;

    function renderAboutCard() {
        if (!tokenName) return null;

        return <TokenPageAboutCard tokenName={tokenName} />;
    }

    return <div className={className}>{renderAboutCard()}</div>;
};

export default TokenPageAboutTab;
